export default __webpack_public_path__ + "static/media/fm-2.bd4e81fb.jpg";